import { DraftState, Template } from "../../../../../core/entities/template";
import React from "react";
import { ContentHeader } from "../../../../components/structure/ContentHeader";
import { Button } from "../../../../components/buttons/Button";
import { TemplatePdfView } from "./TemplatePdfView";
import { ReplacementField } from "../../../../../core/entities/replacementField";

interface Props {
    selected: Template;
    onMakeDraft: (e: React.MouseEvent<HTMLButtonElement>) => void;
    replacementFields: ReplacementField[];

    onMakeCopy(template: Template): void;

    onEdit(e: React.MouseEvent<HTMLButtonElement>): void;
}

export function TemplateView({
    selected,
    onMakeCopy,
    onEdit,
    onMakeDraft,
    replacementFields
}: Props) {
    return (
        <>
            <div className={"flex justify-between"}>
                <ContentHeader>
                    {selected.title ?? "[N/A Title]"}
                    {selected.draftState === DraftState.Published && (
                        <span
                            className={
                                "text-extra-placeholder-text text-sx font-normal ml-12"
                            }
                        >
                            Publiceret
                        </span>
                    )}
                </ContentHeader>
                <div className={"flex gap-8"}>
                    <Button
                        onClick={(e) => onMakeDraft(e)}
                        theme={"secondary"}
                        size={"s"}
                    >
                        Opret ny kladde
                    </Button>
                    {selected.draftState !== DraftState.Draft && (
                        <Button
                            theme={"secondary"}
                            size={"s"}
                            onClick={() => onMakeCopy(selected)}
                        >
                            Lav en kopi
                        </Button>
                    )}
                    {selected.draftState === DraftState.Draft && (
                        <Button theme={"secondary"} size={"s"} onClick={onEdit}>
                            Rediger
                        </Button>
                    )}
                </div>
            </div>
            <div className={"flex flex-1 justify-center"}>
                <TemplatePdfView
                    selected={selected!}
                    replacementFields={replacementFields}
                />
            </div>
        </>
    );
}
